// Returned by /Admin/Request/AcceptRegistration instead of accepting when the registration would
// break working-time-act rules. Retry with ignoreWorkingTimeWarnings=true once the admin confirms.
export interface WorkingTimeWarning {
    title: string;
    message: string;
    shifts: string[];
}

const escapeHtml = (text: string): string => {
    const element = document.createElement('div');
    element.textContent = text;
    return element.innerHTML;
};

/**
 * The warnings as HTML, for the generic PopupModel whose content is bound with `html:`.
 */
export const workingTimeWarningsHtml = (
    warnings: WorkingTimeWarning[],
): string =>
    warnings
        .map((warning) => {
            const shifts =
                warning.shifts.length > 0
                    ? `<ul style="margin: 0.5rem 0 0; padding-left: 1.25rem;">${warning.shifts
                          .map((shift) => `<li>${escapeHtml(shift)}</li>`)
                          .join('')}</ul>`
                    : '';

            return `<div class="alert alert-warning" style="margin-bottom: 1rem; padding: 1rem; background-color: #fef9e7; border: 1px solid #f39c12; border-radius: 4px;">
                <strong>${escapeHtml(warning.title)}</strong>
                <p style="margin: 0.5rem 0 0;">${escapeHtml(warning.message)}</p>
                ${shifts}
            </div>`;
        })
        .join('');
